(() => {
  const grid = document.getElementById("mib-wishlist-grid");
  if (!grid) return;

  const SPINNER_HTML = `<div class="mib-wishlist-loading-spinner"><div class="mib-wishlist-spinner" aria-hidden="true"></div></div>`;

  const EMPTY_HTML = `<div class="mib-wishlist-empty-state">
    <p class="mib-wishlist-empty-state__title">${window.mibWishlistTranslations?.emptyWishlist ?? "Your wishlist is empty"}</p>
  </div>`;

  const ERROR_HTML = `<div class="mib-wishlist-empty-state mib-wishlist-empty-state--error">
    <svg class="mib-wishlist-empty-state__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <p class="mib-wishlist-empty-state__title">${window.mibWishlistTranslations?.couldNotLoad ?? "Could not load wishlist"}</p>
    <p class="mib-wishlist-empty-state__text">${window.mibWishlistTranslations?.invalidLink ?? "The link may be invalid or expired. Try again later."}</p>
  </div>`;

  const itemKey = (item) => `${item?.productId ?? ""}|${item?.variantId ?? ""}`;

  let previousItemKeys = new Set();

  const esc = (s) => {
    const str = String(s ?? "");
    return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };

  const showLoading = () => {
    grid.setAttribute("data-mib-wishlist-loading", "true");
    grid.innerHTML = SPINNER_HTML;
  };

  const getItems = (source) => {
    const list = source?.items;
    return Array.isArray(list) ? list : [];
  };

  const renderItems = (list) => {
    const items = Array.isArray(list) ? list : [];
    previousItemKeys = new Set(items.map(itemKey));
    if (items.length === 0) {
      grid.innerHTML = EMPTY_HTML;
      return;
    }
    grid.innerHTML = `<div class="mib-wishlist-grid__image"><svg xmlns="http://www.w3.org/2000/svg" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" id="Warstwa_1" version="1.1" viewBox="0 0 761.6 273.2">
        <path d="M435.8,110.8c0,11.3-7.9,16.9-18.9,16.9s-16.1-4.7-16.1-4.7l1.1-9.6c4.3,7,10.4,9.5,15.6,9.5s10-2.6,10-8.9-3.5-8.8-8.4-11.4l-6.1-3.3c-5.8-3.1-11.7-7.7-11.7-16.4s8.7-16.2,19.3-16.2,13,3.4,13.2,3.9l-1.2,7.9s-3.5-7.1-12-7.1-10.5,2.6-10.5,8.5,1.8,7.3,6.9,10.1l8,4.4c6.4,3.6,10.8,8,10.8,16.3ZM368.2,98.3h19.3v-4.9h-19.3v-21.4l21.8,3.2v-7.1h-32v58.3h32.8v-7.1l-22.7,3.2v-24.1ZM306.9,84.4c0-10.9-6.8-12.2-14.2-12.2h-3.8v24.8h4.7c7,0,13.3-2.3,13.3-12.6ZM305.7,99l15.3,27.4h-12.1l-12.5-25.5h-7.5v25.5h-10.1v-58.3h15.7c9.8,0,23.3,2.1,23.3,15.7,0,8.8-4.6,13.3-12,15.2ZM161.5,51.4h-10.5l-6.8,10.7h5.7l11.6-10.7ZM158.9,111c0-10.3-6.4-12.7-14.5-12.7h-5.4v15.1c0,6,3.1,10,9.5,10s10.4-4.3,10.4-12.3ZM139.1,94.2h5.2c7.4,0,12.7-2.6,12.7-11s-8.2-11.1-13.1-11.1h-4.9v22ZM169.7,111.2c0,12.9-10.2,16.5-18.6,16.5s-10.6-2.2-13-4l-9.2,3.5v-59.1h18.2c9,0,20.6,2.4,20.6,14.2s-5.2,11.2-10.7,13.1c6.8,2.2,12.7,5.9,12.7,15.7ZM253.6,84.4c0-10.9-6.8-12.2-14.2-12.2h-3.8v24.8h4.7c7,0,13.3-2.3,13.3-12.6ZM252.4,99l15.3,27.4h-12.1l-12.5-25.5h-7.5v25.5h-10.1v-58.3h15.7c9.8,0,23.3,2.1,23.3,15.7,0,8.8-4.6,13.3-12,15.2ZM190.6,98.3h19.3v-4.9h-19.3v-21.4l21.8,3.2v-7.1h-32v58.3h32.8v-7.1l-22.7,3.2v-24.1h0ZM343.1,68.1h-10.1v58.3h10.1v-58.3Z" fill="#c62f2d"/>
        <g>
            <path d="M55.6,219.3v-44.3l30.1,31.6v-28.7h6.3v44.1l-30.1-31.5v29h-6.3Z" fill="#c62f2d"/>
            <path d="M143.2,198.6c0,12.2-9.1,21.5-21.6,21.5s-21.6-9.3-21.6-21.5,9.1-21.5,21.6-21.5,21.6,9.3,21.6,21.5ZM136.9,198.6c0-9.2-6.3-15.7-15.2-15.7s-15.2,6.5-15.2,15.7,6.3,15.7,15.2,15.7,15.2-6.5,15.2-15.7Z" fill="#c62f2d"/>
            <path d="M164.4,219.3l8.7-44.6,14.4,32.2,14.6-32.2,7.8,44.6h-6.5l-4.2-25-12.1,26.9-11.9-27-4.4,25.1h-6.5Z" fill="#c62f2d"/>
            <path d="M259.9,198.6c0,12.2-9.1,21.5-21.6,21.5s-21.6-9.3-21.6-21.5,9.1-21.5,21.6-21.5,21.6,9.3,21.6,21.5ZM253.5,198.6c0-9.2-6.3-15.7-15.2-15.7s-15.2,6.5-15.2,15.7,6.3,15.7,15.2,15.7,15.2-6.5,15.2-15.7Z" fill="#c62f2d"/>
            <path d="M275.2,177.8c5,0,8.3.6,10.9,2.4,4.5,3,4.9,8,4.9,9.8,0,6-3.7,10.3-9.2,11.6l12.9,17.7h-7.7l-11.9-17h-1.1v17h-6.3v-41.5h7.4ZM274.1,196.9h2c1.7,0,8.8-.2,8.8-6.8s-5.5-6.4-8.7-6.4h-2.2v13.2Z" fill="#c62f2d"/>
            <path d="M323.9,183.8h-16.6v10.5h16.1v6h-16.1v13.1h16.6v6h-22.9v-41.5h22.9v6Z" fill="#c62f2d"/>
            <path d="M345.3,219.3l8.7-44.6,14.4,32.2,14.6-32.2,7.8,44.6h-6.5l-4.2-25-12.1,26.9-11.9-27-4.4,25.1h-6.5Z" fill="#c62f2d"/>
            <path d="M405.9,177.8v41.5h-6.3v-41.5h6.3Z" fill="#c62f2d"/>
            <path d="M433.8,187c-.4-.9-.9-1.8-1.9-2.6-1.3-1.1-2.7-1.5-4.5-1.5-3.9,0-5.8,2.3-5.8,5s.4,3.4,4.5,5l4.2,1.7c7.7,3.1,9.8,7.5,9.8,12.2,0,7.9-5.6,13.3-13.4,13.3s-7.7-1.8-9.8-4.2c-2.2-2.5-3.2-5.2-3.5-8.1l6.3-1.4c0,2.1.7,4,1.7,5.3,1.2,1.5,2.9,2.5,5.4,2.5,3.9,0,6.8-2.8,6.8-7s-3.2-6-6-7.1l-4-1.7c-3.4-1.4-8.5-4.3-8.5-10.5s4.4-10.9,12.1-10.9,7,1.7,8.3,2.8c1.1,1,2.3,2.4,3.2,4.2l-5.1,3Z" fill="#c62f2d"/>
            <path d="M464.6,187c-.4-.9-.9-1.8-1.9-2.6-1.3-1.1-2.7-1.5-4.5-1.5-3.9,0-5.8,2.3-5.8,5s.4,3.4,4.5,5l4.2,1.7c7.7,3.1,9.8,7.5,9.8,12.2,0,7.9-5.6,13.3-13.4,13.3s-7.7-1.8-9.8-4.2c-2.2-2.5-3.2-5.2-3.5-8.1l6.3-1.4c0,2.1.7,4,1.7,5.3,1.2,1.5,2.9,2.5,5.4,2.5,3.9,0,6.8-2.8,6.8-7s-3.2-6-6-7.1l-4-1.7c-3.4-1.4-8.5-4.3-8.5-10.5s4.4-10.9,12.1-10.9,7,1.7,8.3,2.8c1.1,1,2.3,2.4,3.2,4.2l-5.1,3Z" fill="#c62f2d"/>
            <path d="M501.6,183.8h-16.6v10.5h16.1v6h-16.1v13.1h16.6v6h-22.9v-41.5h22.9v6Z" fill="#c62f2d"/>
            <path d="M518.6,177.8c5.8,0,10.8.6,15.4,4,5,3.8,8,9.8,8,16.7s-2.9,12.9-8.3,16.7c-4.9,3.4-9.4,4-15.2,4h-8.6v-41.5h8.7ZM516.2,213.4h2.7c3.1,0,7.4-.2,11-2.9,2.9-2.2,5.7-6.2,5.7-11.8s-2.6-9.8-5.6-11.9c-3.6-2.6-8-2.9-11.1-2.9h-2.7v29.6Z" fill="#c62f2d"/>
            <path d="M585.9,197.7h17.1v.3c0,7.1-2.1,12.9-6.2,16.8-4.3,4.2-9.4,5.3-14.1,5.3s-10.3-1.7-14.1-5.7c-4-4.2-6.2-9.7-6.2-15.7s2.6-12.1,6-15.5c3.5-3.6,9.2-6.2,15.6-6.2s7.6.8,10.8,2.6c3.4,1.9,5.5,4.4,6.7,6.2l-5,3.5c-1.2-1.7-3.1-3.6-5.1-4.7-2.3-1.4-4.8-1.8-7.3-1.8-5.4,0-8.9,2.2-10.9,4.3-2.7,2.7-4.4,7.2-4.4,11.6s1.6,8.3,4.3,11.3c2.9,3,6.4,4.2,10.4,4.2s6.6-1.1,9.3-3.7c2.3-2.2,3.2-4.7,3.5-7h-10.3v-5.8Z" fill="#c62f2d"/>
            <path d="M617.3,177.8v41.5h-6.4v-41.5h6.4Z" fill="#c62f2d"/>
            <path d="M648,183.8h-14.4v10.5h13.9v6h-13.9v19h-6.4v-41.5h20.8v6Z" fill="#c62f2d"/>
            <path d="M666.7,183.8v35.5h-6.3v-35.5h-9.5v-6h25.4v6h-9.5Z" fill="#c62f2d"/>
            <path d="M699.7,187c-.4-.9-.9-1.8-1.9-2.6-1.3-1.1-2.7-1.5-4.5-1.5-3.9,0-5.8,2.3-5.8,5s.4,3.4,4.5,5l4.2,1.7c7.7,3.1,9.8,7.5,9.8,12.2,0,7.9-5.6,13.3-13.4,13.3s-7.7-1.8-9.8-4.2c-2.2-2.5-3.2-5.2-3.5-8.1l6.3-1.4c0,2.1.8,4,1.7,5.3,1.2,1.5,2.9,2.5,5.4,2.5,3.9,0,6.8-2.8,6.8-7s-3.2-6-6-7.1l-4-1.7c-3.4-1.4-8.5-4.3-8.5-10.5s4.4-10.9,12.1-10.9,7,1.7,8.3,2.8c1.1,1,2.3,2.4,3.2,4.2l-5.1,3Z" fill="#c62f2d"/>
        </g>
        <g>
            <path d="M458.7,126.3c-.3-.7.2-1.2-.6-2,0,0-.3,0-.4-.1-.1,0-.1-.3-.3-.4-1.5-.7-3.7-.9-5.1,0-.5.3-.9.9-1.2,1.3,0,.1-.3.1-.4.3-.4,1,.7,1.5.9,2.2.1.5.2,2.2,0,2.6-.1.2-.7.6-.8.8-.3.4-.7,1.4-.9,1.6-.2.2-.6.1-.6.4,0,.2.2.5.2.8,0,.3-.2.5-.2.8,0,1.1,2,.1,2.5-.2,2-1.1,6.1-4.5,7.2-6.5,0-.2,0-.5.1-.6,0-.2.4,0,.3-.5,0-.1-.6-.3-.7-.6Z" fill="#c94339"/>
            <path d="M596.9,104.1c0-1.1-.8-.6-1-.7.2-1,0-2-.6-2.8-.5-.7-1.5-.9-2.3-.6-.2,0-.3.3-.4.4-.7.3-2.7,1-3.1,1.7-.1.3,0,.6-.2.8-.4.8-1.1.8-.4,1.9l-2.1,1.9c-.3-.8.3-1.1.4-1.6.7-2.1-.9-1.1-1.9-.4,0-.1,0-.2-.1-.3-1-1.1-1.9-2.2-3.2-3.1-3.4-2.4-7.9-2.8-12-1.7-1.2.3-5.3,3.8-5.8,5-.1.3-.1.8-.2,1-.1.1-.5,0-.7.4-.2.3,0,.8-.1,1.1-.4.7-1.4,2.1-2,2.9-.8,1.1-.9,1.4-1.6,2.6-.4.7-1.2,1.3-1.6,2-1,1.7-1.7,3.6-2.9,5.3-.1.2-.5.2-.6.4,0,0-.4,1.4-.4,1.5-.2,1.3.1,2.6,1,3.6,1.3,1.5,3.3,2.5,5.3,2.7.5,0,5.2-.7,5.7-.9,2.9-1.2,7.6-5.2,10.1-7.3,3.7-3.1,6.9-6.7,10.5-10,.4-.3,1.1-.6,1-1,.6.3-.1.7-.1.8-.2.4-.3.9-.5,1.3-.1.2-.7.2-.3.7.2,0,.5,0,.8,0,.2,0,2.3-2.5,2.8-2.9.1-.1,1-.8,1.1-.7.2.6-.3.6-.4.9-.5,1.1-.7,3.9-1.7,4.4-.2,0-.4,0-.6.1,0,0-1.1,1.7-1.1,1.8,0,.3.3.6.2,1-.4,1.1-2,2.6-2.3,3.8,0,0-.4-.5-.8-.3,0,0-.5.5-.5.6,0,.3.3.9.1,1.1-.1.2-1.2.7-1.4.9-.9.8-.9.9-2.1,1.6,0,0-.5.8-.5.3,0-.5.7-1,.5-1.6,0-.5-1.1.6-1.2.7-.2.1-.7.5-.8.6-.2.2-1.3,1.5-1.4,1.8-.4,1.2.4,1.4.4,1.6,0,.4-.4.6-.3.9,0,0,.3,0,.3.2.2.8,0,1.4.6,2.3,0,0,1,1.1,1.1,1.1,1.1.3,2.1,0,2.8-.8.8-1,.4-1.3.7-2.2,1-3.2,4.8-7.5,6.5-10.5,2.5-4.2,5.3-8.9,6.8-13.1.1-.4.4-.5.4-1ZM578.8,114c-.6.2-1.1,0-1.7.5-.4.3-.5.9-1,.9-.2,0-.5-.4-.6-.3,0,0,0,.2,0,.3-.8.7-.6.7-1.1,1.5-.2.3-2.5,1.5-3.2,1.9-2.3,1.4-3.8,2.5-6.4,3.6-1.1.5-5.1,2.5-4-.4.4-1.2,2.2-3.9,2.9-5,2-3,4.6-5.7,7-8.3.9-1.1,1.5-2.3,3.1-2.6,1.4-.2,6.2.7,6.8,2.1.6,1.4-.8,2-1,3.3.7.3,1.2-.2,1.9-.2.3.2-2.2,2.6-2.6,2.7ZM580.4,124.7c0,.1-.3,0-.2-.3,0-.1.3,0,.2.3Z" fill="#c94339"/>
            <path d="M544.2,92c2.3-2.3,4.4-5.7,6.4-8.2.7-.9,2.8-2.5,3.2-3,.2-.3.5-1.3.7-1.5.1-.1.4,0,.6-.2,1.1-.7,2.2-2.5,3.1-3.6.7-.9,1.4-2,2.1-2.9.4-.5,1.6-1.2,1.4-2,0,0-.9-.9-.9-1,0-.2,0-.5-.1-.8-.2-.5-1.4-1.8-1.9-2-.6-.3-2-.3-2.7-.2-.7,0-1.1.4-1.6.5-.6.1-1.6-.1-2.2,0-.4.1-4.2,2.1-4.6,2.4-.2.1-.3.6-.7.9-.8.7-1.9,1.3-2.6,2-.2.2-.4.2-.4.5,1.1.3,1.1-.5,1.5-.8.7-.5,1.5-1.1,2.2-1.6.2-.2,1.4-.8,1.2,0l-5.6,4.1c-4.9,4.6-8.6,9.9-11.8,15.8-.6,1.1-1.1,2.6-1.6,3.6-.2.3-.9.7-1,.9-.1.3,0,.6-.1.8,0,0-.3,0-.4.3-.1.3,0,.8,0,1.1,0,.1-1.2,1.9-1.3,2.2-.8,1.3-2,2.9-3,4.1-.6.7-3.6,3-3.7,3.5-.1.4,0,1.4,0,1.8.2.4.8.2.8.5-.3,0-.8.5-.9.7-.3.3-1,1.7-1,2,0,.2.5.5.5.6,0,0-.4,0-.5.2,0,.3.3.5.3.6,0,0-.3,1-.3,1-.1.2-.7.2-.4,1-.4-.1-.8-.2-1.2,0-.6.3-1.2,2.3-1,2.9.2.7.6,0,.8-.3.2-.2.4-.4.6-.4,0,.5-.4,2.1-.9,2.2-.5.2-1-1.2-1.2.7,0,.8.1,3.2.6,3.9.1.2.4.2.5.4.1.3-.2,1.3,0,2.2.8,2.5,2.2,0,2.5,0,1.4-.4,3.4.5,4.7.3.5,0,1.7-.9,2-1.4.7-1.2-1.1-1.5-1.9-1.7-.9-.3-2.4-.3-3.2-.6-.4-.1-.3-.8-.2-1.1.2-1.2.9-2.7,1.2-3.9,0-.3,0-.7,0-1.1.8-2.9,1.2-4.9,3.1-7.2,1.7-2.1,3.7-4.1,5.4-6.2,1.2-1.4,3.7-2.9,5.2-4.2,2.7-2.3,5.8-5.3,8.3-7.8ZM533.9,96.5c-.8-.7.4-1.4.2-2.1-.3,0,0,.5-.2.6,0,0-.3,0-.5.1-.2.2-.5.9-1.1.1-.5-.6.5-1.6.8-2.1.2-.4,1.5-3,1.6-3,.4-.3.5.3.5.3.8.1,1-1.7,1-2.3,0-.4-.4-1.1.3-1.3,1.1-.3.3.8.8,1.1.4-1,.9-2,1.5-2.9,2.5-3.8,8.4-10,12.2-12.4.4-.3,2.6-1.6,2.9-1.6,1,0,.3,1.3.4,1.4.3.2,1.6-.9,2.3-.8,1.5.2-1,1.8-1.2,2.1-1.8,1.7-2.9,2.6-4.6,4.5-1.9,2.1-4.1,4.2-5.9,6.4-3.2,4-5.8,8.3-10,11.5-.3.2-.9.7-1.2.6Z" fill="#c94339"/>
            <path d="M490.2,115.5c.7-.1.6-.7.8-1,.2-.3.8-.4.8-.5.2-.2,0-.6,0-.8,0,0,.8-.3,1.1-.4,1.4-.9,2.3-2.7,3.2-3.8,2.2-2.6,5.2-4.2,8.1-5.9.2-.1.6,0,.7-.3.4-.5-.7-.4-.7-.6.8-.2,1.8,0,2.6-.2.3,0,.5-.3.7-.4,1.1-.3,2.9-.6,4.1-.4.5.1.3.7.7.8,1,.4,1.5-.8,1.3,1.3.1,0,.4,0,.5,0,0,0,.4-.9.4-1.1.4-1.4.3-2.8-1.1-3.4-.7-.3-3.6-.4-4.4-.3,0,0-1.1.5-1.3.6-1.9.8-3.6,1.8-5.3,2.7-4.4,2.4-7.5,5.5-10.9,9-.9,1-1.2,1.6-2,2.9,0,.1-.3.1-.4.3,0,.3,0,1.1,0,1.2,0,0-.5,0-.8,0-.2.1-1.4,1.5-1.6,1.8-.2,0-1-.4-1.1-.5,0,0,0-1.4,0-1.6.2-1.2,1.4-3.6,1.9-4.7,2.3-5.1,4.9-10.1,8.1-15.2.1-.2.6-.4.8-.9.2-.5.2-.9.1-1.4-.9-.2-1.8,0-2.2.8-.3,0-.2-.6-.3-.6-.1-.1-1.1.3-1.2.5-.7.7-.2,2-.4,2.6,0,.1-.6.3-.5.7-.2-.1-.5-.9-.9-.3-.2.4.4,1.1.4,1.1,0,0-.2,0-.3.1-.6.6-.3.2-1.1.4-1.2.2,0,1.4,0,1.8,0,.1-.3.2-.4.3-.2.2-.6,1.2-.6,1.2-.2.1-.9-.1-1.3.1,0,0-.9.9-1,1.1-1,1.2.3,1.2.4,1.5.2.7-.6.9-.5,1.6-.3,0-.3-.4-.6-.2-.3.1-1.1,2.3-1.2,2.8-.2.9-.3,1.5-.5,2.3-.2,1.1-2.2,3.8-2.8,5.1-.2.3-1,2.5-1,2.8,0,.5.1,1.1,0,1.6,0,0-.7.6-.8,1-.4,1-.7,2.2-1.1,3.2-.9,2.1-2,4.1-2.9,6.2-1.2,2.8-2.7,5.6-4.1,8.3-1.8,3.4-3.4,6.2-5.3,9.6-.6,1-2.1,3.4-2.4,4.4-.4,1.3,0,1.3.8,1.8.1,0,.1.4.3.4.3.1.6-.4.7-.3,0,0,.2.5.6.7.7.3,1.8-.5,2.4-1,1.2-1.1,3.1-4.9,3.9-6.4,3.7-7.6,7.1-15.2,11.2-22.4.8-1.5,1.7-2.5,2.3-4.3,0-.2,0-.6,0-.7,0,0,.6,0,.8,0,.3-.2,0-.7.2-.9,0,0,.9-.4,1.2-.7.1-.1,1.5-1.9,1.5-2,.3-.7,0-.6-.3-.9-.5-.5.4-.2.6-.2Z" fill="#c94339"/>
            <path d="M547.5,118.2c-.3.3-.9.9-1.1,1.3-.3,0-.2-.6-.3-.6-.1,0-.7.1-.8.2-1,.5-2.6,2.5-3.7,3.3-.4.3-1.1.8-1.5,1-.3.2-1.7,1-1.8.9,0,0-.9-.6-.9-.7-.6-.8.6-1.5.8-2.1.2-.7.3-1.8.5-2.5.1-.3.4-.5.5-.8,0-.2,0-1.1,0-1.3,0-.3-.5-.1-.5-.4.1,0,.3,0,.5,0,.8-.5,1.2-1.3,1.9-1.9,1.7-1.6,3.6-2.3,5.6-3.4,3-1.8,6.2-4.1,8.7-6.8.7-.8,1.3-1.7,2-2.6.2-.9-.5-.8-.5-1,0-.4.2-.2.3-.3.6-1,0-2.2-.7-2.9-.5-.6-1.3-1-2.1-.9-.4,0-.5.3-.8.3-2.8.5-4.5.6-7.2,1.5-.4.1-1,.3-1.4.5-.8.3-3.3,2.4-3.9,3.1-.2.2-.8.9-.7,1.2.1.4.9,0,1,.4-.5,0-.7.7-1,.9-.3.2-.8.2-1.3.7-.4.4-2.8,3.7-2.9,4.1-.2.9.2.6-.5,1.5-1.2,1.9-2.1,6.5-2.5,8.8,0,.3-.3.5-.3,1-.1,1,0,2.9.3,3.8.1.4,1.6,1.3,1.8,1.9.2.5,0,1,.2,1.4,0,0,1.1,1,1.2,1,.3.1,2.1.2,2.4,0,4.3-1.3,7.9-5.3,10.5-9,.2-.2.7-.5.8-.9.1-.3.2-1.5,0-1.8-.4-.6-2.1.6-2.5,1ZM545.2,106.1c1.2-1.9,4.2-4.6,6.5-4.9l-.3,1.1c.9-.2,1.7-.9,2.7-.5.1,0,.6.4.6.5,0,.2-1,1.4-1.2,1.7-1.7,1.9-4.8,3.5-7.1,4.6-.5.2-1.1.6-1.7.6-.3-.2,2.3-1.7,1.2-1.9-.4,0-2.1,1.1-.7-1.2Z" fill="#c94339"/>
            <path d="M645.6,101.4c-.1-.8.8-1.3.2-2.8-.4-1-.9-1.6-2.1-1.6-2.5,0-7.7,1.4-10,2.6-1,.5-3.1,2.1-3.7,3-.3.5-.4,1.1.3.6.3-.2,0-.3.7-.3,0,0,0-.2,0-.3.3,0,.4,0,.3.3-.1,0-.2,0-.3,0-.4,1.1-2.3,1.8-3.2,2.8-.5.5-2.5,3.3-2.6,3.7-.2.9,0,.6-.5,1.5-1.3,2-2.1,6.6-2.5,8.9,0,.3-.3.4-.3.8-.1,1.1,0,2.9.5,3.8.3.6,1.4,1.3,1.7,1.8.2.5,0,1,.2,1.4,0,.1,1.2,1.1,1.4,1.1.3,0,1.9,0,2.2,0,3.8-1.2,7.3-4.8,9.8-7.9.6-.7,1.1-1.5,1.6-2.2.5-3.1-1.9-1.2-3-.1-.3.3-1.1,1.6-1.5,1.3l.3-.8c-.5-.5-2.1,1.6-2.5,1.9-.7.6-1.7,1.3-2.5,1.8-.6.4-2.1,1.6-2.7,1.5-.9-.1-1.7-1.3-1.6-2.2.6.3,1-.7,1.1-1.2.3-1.2-.5-.6-.6-1.3-.1-.6.6-.6.3-1.4.9-.2,0,.7.8.6,0-.6.6-1.3.5-1.8,0-.2-.4-.3-.4-.5-.2-.6.8-.8,1.1-1.1.7-.6,1.2-1.6,2-2.2,2.3-1.7,5.5-2.8,7.9-4.5,1.6-1,3.7-2.9,5-4.3.4-.4,2.3-2.5,2.3-3,0-.3-.3-.2-.3-.3ZM641,105.7c-1.1.8-5.2,3.1-6.3,3.4-.5.1-1,0-.6-.4.3-.4,1.2-.6,1.3-1.3-.3-.2-2,1-1.5-.5.5-1.5,4.2-4.8,5.7-5.5.8-.4,1.8-.8,1.6.6.6,0,1.1-.5,1.7-.5.2,0,1.1.4,1.2.5.4.6-2.4,3.3-3,3.7Z" fill="#c94339"/>
            <path d="M616,102.1c1.3-1.2,2.1-2.1,3.7-2.9,1.4-.7,2.9-1.1,4.2-2,1-.6,1-2.3,0-2.9-.7-.5-1.4-.4-2.2-.6-.5-.1-1.3-.8-2-.3-.9.6-.7.2-1.6.4-.8.2-4.2,2.8-4.6,3.5-.3.5,0,.7-.1,1.1,0,0-.9.7-.8,1.3,0,.5.6,0,.7,0,0,0,.6.7.6.8-.6.3-1,1-1.7,1.3-.3.2-.7.1-1,.3-.2.1-.9,1.9-1.2,2.2-.2.2-1,0-1.1.3-.1.2,0,.6-.2.8-.5.9-3.6,4.5-4.4,5.1-.7.5-1.3.2-2,1.2-.8,1.2-.6,2.4.5,3.3,1.7,1.4,3.7.8,5.5,1.4.3,0,.6.4.8.4.3,0,.6-.1.9-.1.5,0,1,1,1.6,1.1l.2.3c-.1.5-.6.6-.8.8-.2.2-.2.8-.6.8-.3,0-.4-.4-.9-.3-.4,0-2.4,1.8-3.2,2.2-2.1,1-4.4,1.4-6.7,1.6-.5-.1.4-1.4-.5-1.7-1.3-.4-2.2.9-3.2,1-.4,0-.6-.6-1.5-.4-.4,0-1.2.8-1.3,1.2-.3,1.1.2,1,.4,1.6.3.7,0,.9.8,1.6,1.7,1.6,4.3,1,6.5.8,4.1-.4,7.6-.9,11-3.3,1.9-1.4,5.8-4.6,6.3-6.9.2-1-.6-1-1.3-.5,0-1.1-.9-2.9-1.8-3.5-.2-.2-.5-.1-.7-.2,0,0-.2-.4-.4-.4h-6.6c-.2-.9.4-1.3.8-1.9,1.8-2.6,6-6.3,8.2-8.4ZM616.5,97.9c0,0-.8,1.1-1.1.6,0-.4.8-.9,1.1-.6Z" fill="#c94339"/>
            <path d="M515,103.2c-.9.7-2.5,2.9-3.4,4-1.9,2.2-3.7,4.5-5.8,6.5l-.5-.6c-.2.2-1.8,1.5-1.5.6.3-1,2.1-2.3,2.8-3,.2-.2.3-.5.4-.7.2-.3,1.1-.8-.3-.6-1.3,1.2-2.2,2.7-3.6,3.9-3.1,2.7-5.8,4.9-9.3,7-1.3.7-5,.9-3.5,3.2.2.3,1.2,1,1.5,1.1.8.2,1.8,0,2.5,0,.7,0,.6.5,1.6.2,2.1-.7,7.5-5.8,9.2-7.6,3.2-3.4,7.4-8.2,10-11.9.3-.4,1.4-2.1,1.3-2.4-.1-.6-1.5.3-1.7.5Z" fill="#c94339"/>
            <path d="M508.5,109.2c-.3.2-2.4,2.7-2.4,2.9,0,.2.2.5.5.4,0-.5.6-.9,1-1.4.5-.6,1.3-1.4,1.7-2.1.1-.2,0-.4,0-.4-.2.2-.5.3-.7.5Z" fill="#c94339"/>
        </g>
        </svg></div>`;
    grid.innerHTML += items.map((item) => `
      <article class="mib-wishlist-card" role="listitem" data-mib-product-id="${esc(item.productId)}" data-mib-variant-id="${esc(item.variantId ?? "")}">
        <a class="mib-wishlist-card__image" href="/products/${esc(item.productHandle)}"><img src="${esc(item.image)}" alt="${esc(item.productTitle)}" loading="lazy" /></a>
        <div class="mib-wishlist-card__info">
            <h3>${esc(item.productTitle)}${item.variantTitle == "Default Title" ? "" : " - " + esc(item.variantTitle)}</h3>
            <p>${item.price ?? ""}</p>
        </div>
        <div class="mib-wishlist-card__actions">
          <button type="button" class="mib-wishlist-add-to-cart primary" data-mib-wishlist-add-to-cart data-mib-product-id="${esc(item.productId)}" data-mib-variant-id="${esc(item.variantId ?? "")}">
            ${window.mibWishlistTranslations?.addToCart ?? "Add to Cart"}
          </button>
          <button type="button" class="mib-wishlist-remove" data-mib-wishlist-remove data-mib-product-id="${esc(item.productId)}" data-mib-variant-id="${esc(item.variantId ?? "")}">
            ${window.mibWishlistTranslations?.remove ?? "Remove"}
          </button>
        </div>
      </article>
    `).join("");

    handleAddToCart();
  };


  const apply = (source) => {
    const loading = source?.loading === true;
    grid.setAttribute("data-mib-wishlist-loading", loading ? "true" : "false");
    if (loading) {
      if (previousItemKeys.size === 0) grid.innerHTML = SPINNER_HTML;
      return;
    }
    const newItems = getItems(source);
    const newKeys = new Set(newItems.map(itemKey));
    const removedKey = previousItemKeys.size === newKeys.size + 1 && [...previousItemKeys].find((k) => !newKeys.has(k));
    if (removedKey && !grid.querySelector("[data-product-card-model-key]")) {
      const cards = grid.querySelectorAll(".mib-wishlist-card");
      for (const card of cards) {
        const k = itemKey({ productId: card.getAttribute("data-mib-product-id"), variantId: card.getAttribute("data-mib-variant-id") });
        if (k === removedKey) {
          card.remove();
          previousItemKeys = newKeys;
          if (previousItemKeys.size === 0) grid.innerHTML = EMPTY_HTML;
          return;
        }
      }
    }
    renderItems(newItems);
  }; 

  const handleAddToCart = () => {
    const addToCartButtons = grid.querySelectorAll("[data-mib-wishlist-add-to-cart]");
    for (const btn of addToCartButtons) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        document.dispatchEvent(new Event("theme:loading:start"));

        var item = {
          quantity: 1,
          id: btn.getAttribute("data-mib-variant-id") || btn.getAttribute("data-mib-product-id"),
          properties: {},
        };

        fetch(`${window.Shopify.routes.root}cart/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [item],
          }),
        }).then(() => {
          window.location.href = `${window.Shopify.routes.root}cart`;
        });

      });
    }
  }

   const runShareByCode = (code) => {
    const api = window.MIB_Wishlist?.getSharedWishlistByCode;
    if (typeof api !== "function") return false;
    showLoading();
    api(code)
      .then((data) => {
        const el = document.getElementById("mib-wishlist-grid");
        if (!el) return;
        const fn = window.MIB_Wishlist_renderShareItems;
        if (data?.items?.length && fn) fn(data.items, el);
        else { el.removeAttribute("data-mib-wishlist-loading"); el.innerHTML = EMPTY_HTML; }
      })
      .catch(() => {
        const el = document.getElementById("mib-wishlist-grid");
        if (el) { el.removeAttribute("data-mib-wishlist-loading"); el.innerHTML = ERROR_HTML; }
      });
    return true;
  };

  const waitForMibWishlist = (code, maxMs) => {
    const start = Date.now();
    const tick = () => {
      if (runShareByCode(code)) return;
      if (Date.now() - start >= (maxMs ?? 8000)) {
        grid.removeAttribute("data-mib-wishlist-loading");
        grid.innerHTML = ERROR_HTML;
        return;
      }
      setTimeout(tick, 150);
    };
    tick();
  };

  grid.innerHTML = SPINNER_HTML;
  grid.setAttribute("data-mib-wishlist-loading", "true");

  // Track which button triggered the share
  let pendingShareButton = null;

  // Get share URL with code parameter
  const getShareUrl = (shareCode) => {
    const url = new URL(window.location.href);
    url.searchParams.set('share', shareCode);
    return url.toString();
  };

  // Show email share form modal
  const showEmailFormModal = (shareUrl) => {
    const existingModal = document.getElementById('mib-email-share-modal');
    if (existingModal) existingModal.remove();

    const modal = document.createElement('div');
    modal.id = 'mib-email-share-modal';
    modal.innerHTML = `
      <div class="mib-share-modal-overlay"></div>
      <div class="mib-share-modal-content">
        <div class="mib-share-modal-header">
          <h2>${window.mibWishlistTranslations?.sendToFriend ?? "Wyślij znajomemu"}</h2>
            <button class="mib-share-modal-close" type="button" aria-label="Close">
            <svg class="Icon Icon--close " viewBox="0 0 16.239 16.238">
              <g id="Path_607" data-name="Path 607" transform="translate(-66.835 -72.18)" fill="none">
                <path d="M83.074,72.668l-.488-.488L74.955,79.81,67.324,72.18l-.488.488L74.466,80.3,66.836,87.93l.488.488,7.631-7.631,7.631,7.631.488-.488L75.443,80.3Z" stroke="none"></path>
                <path d="M 67.32398986816406 72.17959594726562 L 74.95474243164062 79.81034088134766 L 82.58547973632812 72.17959594726562 L 83.073974609375 72.66806030273438 L 75.44319915771484 80.29880523681641 L 83.073974609375 87.92957305908203 L 82.58547973632812 88.41802978515625 L 74.95474243164062 80.78726959228516 L 67.32398986816406 88.41802978515625 L 66.83551025390625 87.92957305908203 L 74.46628570556641 80.29880523681641 L 66.83551025390625 72.66806030273438 L 67.32398986816406 72.17959594726562 Z" stroke="none" fill="#000"></path>
              </g>
            </svg>
          </button>
        </div>

        <div class="mib-share-modal-body">
          <form id="mib-share-form" class="mib-share-form">
            <div class="mib-share-form-row">
              <input type="text" id="mib-share-first-name" placeholder="${window.mibWishlistTranslations?.firstName ?? "Imię"}" class="mib-share-input" />
              <input type="text" id="mib-share-last-name" placeholder="${window.mibWishlistTranslations?.lastName ?? "Nazwisko"}" class="mib-share-input" />
            </div>
            <input type="email" id="mib-share-friend-email" placeholder="${window.mibWishlistTranslations?.friendEmail ?? "Email znajomego"}" required class="mib-share-input" />
            <textarea id="mib-share-message" placeholder="${window.mibWishlistTranslations?.message ?? "Wiadomość"}" class="mib-share-textarea"></textarea>
            <button type="submit" class="mib-share-submit-btn">${window.mibWishlistTranslations?.send ?? "Wyślij"}</button>
          </form>
          <p class="mib-share-form-msg" style="display: none;"></p>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    // Close handlers
    modal.querySelector('.mib-share-modal-close').addEventListener('click', () => modal.remove());
    modal.querySelector('.mib-share-modal-overlay').addEventListener('click', () => modal.remove());

    // Form submission
    const form = modal.querySelector('#mib-share-form');
    const formMsg = modal.querySelector('.mib-share-form-msg');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const firstName = (document.getElementById('mib-share-first-name').value || '').trim();
      const lastName = (document.getElementById('mib-share-last-name').value || '').trim();
      const friendEmail = (document.getElementById('mib-share-friend-email').value || '').trim();
      const message = (document.getElementById('mib-share-message').value || '').trim();

      if (!friendEmail) return;

      const api = window.MIB_Wishlist && window.MIB_Wishlist.shareWishlistViaEmail;
      if (typeof api !== 'function') return;

      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = window.mibWishlistTranslations?.sending ?? 'Wysyłanie...';

      try {
        const result = await api({ firstName, lastName, friendEmail, message });
        if (result && result.sent) {
          formMsg.textContent = window.mibWishlistTranslations?.sentSuccess ?? '✓ Wiadomość wysłana pomyślnie!';
          formMsg.className = 'mib-share-form-msg mib-share-form-msg--success';
          formMsg.style.display = 'block';
          form.reset();
          setTimeout(() => { modal.remove(); }, 2000);
        } else {
          formMsg.textContent = window.mibWishlistTranslations?.sendError ?? 'Błąd podczas wysyłania. Spróbuj ponownie.';
          formMsg.className = 'mib-share-form-msg mib-share-form-msg--error';
          formMsg.style.display = 'block';
        }
      } catch (err) {
        formMsg.textContent = (window.mibWishlistTranslations?.errorPrefix ?? 'Błąd: ') + (err.message ?? window.mibWishlistTranslations?.unknownError);
        formMsg.className = 'mib-share-form-msg mib-share-form-msg--error';
        formMsg.style.display = 'block';
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = window.mibWishlistTranslations?.send ?? 'Wyślij';
      }
    });
  };

  // Get centered window position
  const getCenteredWindowPosition = (width, height) => {
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;
    return `left=${left},top=${top}`;
  };

  // Handle share actions based on button type
  const handleShareAction = (shareCode, button) => {
    const shareUrl = getShareUrl(shareCode);

    if (button.hasAttribute('data-share-email')) {
      showEmailFormModal(shareUrl);
    } else if (button.hasAttribute('data-share-copy')) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        const originalContent = button.innerHTML;
        button.innerHTML = window.mibWishlistTranslations?.copied ?? '✓ Skopiowano!';
        button.setAttribute('aria-busy', 'false');
        setTimeout(() => {
          button.innerHTML = originalContent;
        }, 2000);
      });
    } else if (button.hasAttribute('data-share-facebook')) {
      const facebookFeatures = `width=626,height=436,${getCenteredWindowPosition(626, 436)}`;
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, 'facebook-share-dialog', facebookFeatures);
      button.setAttribute('aria-busy', 'false');
    } else if (button.hasAttribute('data-share-twitter')) {
      const twitterFeatures = `width=550,height=420,${getCenteredWindowPosition(550, 420)}`;
      window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(window.mibWishlistTranslations?.twitterShareText ?? 'Check out my wishlist!')}`, 'twitter-share', twitterFeatures);
      button.setAttribute('aria-busy', 'false');
    } else if (button.hasAttribute('data-share-pinterest')) {
      const pinterestFeatures = `width=750,height=500,${getCenteredWindowPosition(750, 500)}`;
      window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}`, 'pinterest-share', pinterestFeatures);
      button.setAttribute('aria-busy', 'false');
    }
  };

  // Initialize share buttons
  const initShareButtons = () => {
    const shareButtons = document.querySelectorAll('[data-mib-wishlist-share]');
    for (const btn of shareButtons) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        pendingShareButton = btn;
      });
    }
  };

  window.addEventListener("mib:wishlist:items", (e) => apply(e?.detail));
  window.addEventListener("mib:wishlist:share-ready", (e) => {
    console.log('wishlist share ready');
    const { shareCode } = e.detail;
    if (shareCode && pendingShareButton) {
      handleShareAction(shareCode, pendingShareButton);
      pendingShareButton = null;
    }
  });

  const MIN_SPINNER_MS = 400;
  const spinnerShownAt = Date.now();

  const codeFromUrl = new URLSearchParams(location.search).get("share")?.trim();
  if (codeFromUrl) {
    window.MIB_Wishlist_renderShareItems = renderItems;
    document.querySelector(".mib-wishlist-share").style.display = "none";
    showLoading();
    if (!runShareByCode(codeFromUrl)) waitForMibWishlist(codeFromUrl);
  } else {
    grid.innerHTML = EMPTY_HTML;
    requestAnimationFrame(() => {
        const elapsed = Date.now() - spinnerShownAt;
        const wait = Math.max(0, MIN_SPINNER_MS - elapsed);
        const run = () => {
        const snapshot = window.MIB_Wishlist?.getSnapshot?.();
        if (snapshot != null) apply(snapshot);
        };
        if (wait > 0) setTimeout(run, wait);
        else run();
    });
  }

  // Initialize share buttons
  initShareButtons();

})();